import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import NavigationConstants from '../LobbyOverlay/NavigationConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../../screens';
import Utils from '../../utils';
import AppInterface from '../../api/AppInterface';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import audio from '../../utils/audio';
import { TooltipTypes } from '../../utils/tooltipConstants';
import RewardCenterOnboarding from '../../utils/rewardCenterOnboarding';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var NavigationBar = /*#__PURE__*/function (_Component) {
  _inherits(NavigationBar, _Component);

  var _super = _createSuper(NavigationBar);

  function NavigationBar(props) {
    var _this;

    _classCallCheck(this, NavigationBar);

    _this = _super.call(this, props);

    _this._changeTooltipType = function (type) {
      if (type !== TooltipTypes.COINS) _this.props.shouldShowTooltip(false);

      _this.setState({
        tooltipType: type
      }, function () {
        if (type) {
          clearTimeout(_this.tooltipTimeout);
          _this.tooltipTimeout = setTimeout(function () {
            _this.setState({
              tooltipType: null
            });

            _this.props.shouldShowTooltip(false);
          }, 2500);
        } else {
          clearTimeout(_this.tooltipTimeout);
        }
      });
    };

    _this.sendStoreOpenedEvent = function (type) {
      var trigger = Logger.getActionTrigger();
      var eventPayload = {
        balance_before: _this.props.coin.value.toString(),
        type: type,
        trigger: trigger || ''
      };
      Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);
    };

    _this._showModal = function (modalType, modalArgs) {
      audio.onClick();
      var _this$props = _this.props,
          sidebarState = _this$props.sidebarState,
          setSidebarState = _this$props.setSidebarState;
      setSidebarState(!sidebarState);

      if (modalType === 'ShopScreen') {
        Logger.setActionTrigger('topBar');
        var type = modalArgs ? 'vip' : 'regular';

        _this.sendStoreOpenedEvent(type);
      }

      if (modalType === Screens.RewardCenter) {
        RewardCenterOnboarding.showModal(modalType);
      } else {
        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modalType));

        if (modalArgs) {
          QueryParamsProxy.setQueryParams(modalArgs);
        }
      }

      _this.props.setModal(modalType);
    };

    _this._addNotif = function (notif) {
      _this.props.addNotif(notif);
    };

    _this._getInitAppResponse = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AppInterface.initApp();

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this._checkForEvents = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return AppInterface.updateAppEvents();

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this.navigateBack = function () {
      audio.onClick();
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Home);
      QueryParamsProxy.updateURL();

      _this._checkForEvents();
    };

    _this.showHomeButton = function () {
      var currentScreen = _this.props.navigation.state.routes[_this.props.navigation.state.index].key;
      return currentScreen === Screens.Game || currentScreen === Screens.Missions ? true : false;
    };

    _this.state = {
      visible: true,
      messageCount: 0,
      tooltipType: null
    };
    _this.tooltipTimeout;
    return _this;
  }

  _createClass(NavigationBar, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var newNavState = nextProps.navState;

      if (newNavState !== this.props.navState) {
        switch (newNavState) {
          case NavigationConstants.HIDE_TOP:
          case NavigationConstants.HIDE_BOTH:
            {
              this.setState({
                visible: false
              });
              break;
            }

          default:
            {
              var isMissionsScreen = this.props.navigation.state.routes[this.props.navigation.state.index].key === Screens.Missions;
              if (this.props.triggerNavStateAnimationFn) this.props.triggerNavStateAnimationFn(newNavState, isMissionsScreen);
              this.setState({
                visible: true
              });
            }
        }
      }
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      if (this.state.visible !== nextState.visible) {
        if (this.props.sharedWillUpdate) {
          this.props.sharedWillUpdate(nextProps, nextState);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          navState = _this$props2.navState,
          coin = _this$props2.coin,
          level = _this$props2.level,
          loyalty = _this$props2.loyalty,
          sale = _this$props2.sale,
          limitedTimeOffer = _this$props2.limitedTimeOffer,
          sidebarState = _this$props2.sidebarState,
          setSidebarState = _this$props2.setSidebarState,
          ftueStep = _this$props2.ftueStep,
          tooltipDetails = _this$props2.tooltipDetails,
          shouldShowTooltip = _this$props2.shouldShowTooltip,
          showLinkLoyaltyCardSetting = _this$props2.showLinkLoyaltyCardSetting,
          activeTutorial = _this$props2.activeTutorial,
          showMissionsProgressBar = _this$props2.showMissionsProgressBar,
          missionsAssets = _this$props2.missionsAssets,
          assetsLoaded = _this$props2.assetsLoaded;
      var IapButtonState = sale ? NavigationBar.EIapButtonStates.Sale : NavigationBar.EIapButtonStates.NoSale;

      if (IapButtonState === NavigationBar.EIapButtonStates.Sale) {
        if (!Utils.isEmpty(limitedTimeOffer)) {
          IapButtonState = NavigationBar.EIapButtonStates.SaleDeal;
        }
      } else if (IapButtonState === NavigationBar.EIapButtonStates.NoSale) {
        if (!Utils.isEmpty(limitedTimeOffer)) {
          IapButtonState = NavigationBar.EIapButtonStates.NoSaleDeal;
        }
      }

      return this.props.render({
        navState: navState,
        IapButtonState: IapButtonState,
        limitedTimeOffer: this.props.limitedTimeOffer,
        coins: coin.value,
        level: format(level),
        loyalty: loyalty.value,
        showModal: this._showModal,
        addNotif: this._addNotif,
        navigateBack: this.navigateBack,
        tooltipType: this.state.tooltipType,
        changeTooltipType: this._changeTooltipType,
        showCoinBalance: navState !== NavigationConstants.HIDE_BOTTOM,
        isMissions: this.props.navigation.state.routes[this.props.navigation.state.index].key === Screens.Missions,
        isHome: this.props.navigation.state.routes[this.props.navigation.state.index].key === Screens.Home,
        isGame: this.props.navigation.state.routes[this.props.navigation.state.index].key === Screens.Game,
        sidebarState: sidebarState,
        setSidebarState: setSidebarState,
        ftueStep: ftueStep,
        tooltipDetails: tooltipDetails,
        shouldShowTooltip: shouldShowTooltip,
        showLinkLoyaltyCardSetting: showLinkLoyaltyCardSetting,
        showHomeButton: this.showHomeButton,
        activeTutorial: activeTutorial,
        showMissionsProgressBar: showMissionsProgressBar && missionsAssets && assetsLoaded
      });
    }
  }]);

  return NavigationBar;
}(Component);

NavigationBar.EIapButtonStates = {
  NoSale: 0,
  Sale: 1,
  NoSaleDeal: 2,
  SaleDeal: 3
};
export { NavigationBar as default };